// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.matrixNodes', {
    url: '/matrixnodes',
    templateUrl: 'main/configuration/matrixNodes/matrixNodes.tpl.html',
    data: { pageTitle: 'Matrix nodes' },
  });
};

angular.module('configuration.matrixNodes', []).config(config);
